module.exports = __webpack_public_path__ + "static/img/mobileproject.bb1f39c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Probuild/mobileproject.png
// module id = YPPj
// module chunks = 0